import { render, staticRenderFns } from "./FooterItem.vue?vue&type=template&id=035c1129&scoped=true&lang=pug&"
import script from "./FooterItem.vue?vue&type=script&lang=js&"
export * from "./FooterItem.vue?vue&type=script&lang=js&"
import style0 from "./FooterItem.vue?vue&type=style&index=0&id=035c1129&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c1129",
  null
  
)

component.options.__file = "FooterItem.vue"
export default component.exports